"use client";
import { useContext } from "react";
import { isMobile } from "react-device-detect";
import { StoreContext } from "~/app/store-provider";
import { StoreI } from "~/interfaces";

export default function MainMenu() {
  const [store, setStore] = useContext(StoreContext);
  const mainNavData = [
    {
      text: "Listings",
      href: "/",
      isSubdomain: true,
    },
    {
      text: "About",
      href: "/about",
    },
    {
      text: "Contact",
      href: "/contact",
    },
    {
      text: "Add App to Phone",
      href: "#",
      isMobile: true,
    },
  ];

  return (
    <div
      className={`${store.app.menu.isMainMenuActive ? `left-0` : `-left-[250px]`} fun-main-menu transition-left absolute top-14 z-10 flex w-[250px] flex-col bg-beige font-[600] uppercase text-brown duration-300 ease-linear lg:top-20`}
    >
      {mainNavData.map((nav, i) => {
        // guard for mobile only links
        if (nav.isMobile && !isMobile) return null;
        // guard for city listings homepage
        if (nav.isSubdomain && !store.app.city) return null;
        return (
          <a
            key={`${nav.text}--${i}`}
            href={nav.href}
            className="flex cursor-pointer items-center justify-start border-t border-brown bg-none p-4 font-[600] tracking-[1] opacity-60 transition-all duration-500 hover:bg-lightorange hover:opacity-100"
            aria-label={nav.text}
            onClick={(e) => {
              // Add App to phone
              if (
                nav.isMobile &&
                typeof window !== "undefined" &&
                window.AddToHomeScreenInstance
              ) {
                e.preventDefault();
                window.AddToHomeScreenInstance.show("en");
              }
              setStore((prevStore: StoreI) => ({
                ...prevStore,
                app: {
                  ...prevStore.app,
                  menu: {
                    ...prevStore.app.menu,
                    isMainMenuActive: false,
                    isSearchActive: false,
                  },
                },
              }));
            }}
          >
            {nav.text}
          </a>
        );
      })}
    </div>
  );
}
